import axios, { type AxiosError } from 'axios';
import { HttpError } from '@/errors/HttpError';

const GENERIC_SEND_ERROR = 'Something went wrong while processing your question.';

function messageFromHttpError(err: HttpError): string {
  const detail = err.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  return err.message || GENERIC_SEND_ERROR;
}

function messageFromAxiosError(err: AxiosError): string {
  const status = err.response?.status;
  if (status) return `Server error (${status}).`;
  return err.message || GENERIC_SEND_ERROR;
}

export function mapAgentChatSendError(err: unknown): string {
  if (err instanceof HttpError) return messageFromHttpError(err);
  if (axios.isAxiosError(err)) return messageFromAxiosError(err);
  if (err instanceof Error) return err.message;
  return GENERIC_SEND_ERROR;
}
